module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main",
    class: {
      active: _vm.showVideo
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('video', {
    ref: "vid",
    staticClass: "intro",
    attrs: {
      "preload": "none",
      "controls": "controls"
    }
  }, [_c('source', {
    attrs: {
      "src": "https://s3-ap-southeast-2.amazonaws.com/siberianlarchwood/bg.mp4",
      "type": "video/mp4"
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "svg-btn",
    on: {
      "click": _vm.stop
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f7347b6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/IntroVideo.vue
// module id = 257
// module chunks = 6